import {post} from "@/tools/http";

export default function getApi() {
    const service = 'examination';

    return {
        saveSession: async(reviewId, activitySessionId, params) => {
            return await post(
                service,
                `expert/event/review/${reviewId}/session/${activitySessionId}`,
                params,
                true,
                {},
            );
        },
        cancelSession: async(activitySessionId) => {
            const res = await post(service, `expert/document/${activitySessionId}/cancel`);
            return res !== null;
        },
        checkSession: async(activitySessionId) => {
            return await post(service, `expert/document/${activitySessionId}/check`);
        },
        sendResults: async(reviewId, sendAll, ids) => {
            const params = {};
            if (sendAll) {
                params.sendAll = 1;
            }
            if (ids) {
                params.ids = ids;
            }
            const resp = await post(
                service,
                `expert/event/review/${reviewId}/send-results`,
                params,
                true
            );
            return resp !== null;
        },
    };
}